import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './registerServiceWorker'
import ApiService from './services/api.service'
import { TokenService } from './services/token.service'
import { L } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

ApiService.init(process.env.VUE_APP_ROOT_API)

if (TokenService.getToken()) {
  ApiService.setHeader()
  ApiService.mount401Interceptor()
}

// this part resolve an issue where the markers would not appear
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.filter('formatDate', value => {
  const date = new Date(value)
  return date.toLocaleDateString('en', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
    // hour: '2-digit',
    // minute: '2-digit'
  })
})

Vue.filter('formatDateTime', value => {
  const date = new Date(value)
  return date.toLocaleDateString('en', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
})

Vue.filter('formatPrice', value => {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('formatLatLng', value => {
  if (typeof value !== 'number') {
    return value
  }
  return value.toFixed(5)
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
